import { render, staticRenderFns } from "./formPermissionSwitch.vue?vue&type=template&id=e5c56a08&"
import script from "./formPermissionSwitch.vue?vue&type=script&lang=js&"
export * from "./formPermissionSwitch.vue?vue&type=script&lang=js&"
import style0 from "./formPermissionSwitch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports